import styled from 'styled-components'

import { Colours } from '@/utils/styles'

export const Select = styled.select`
  margin: 10px 5px;
  background: white;
  border-style: solid;
  border-color: rgba(188, 190, 192, 0.5);
  border-width: 1px;
  padding: 18px;
  border-radius: 5px;
  position: relative;
  text-align: left;
  outline: none;
`

export const CentredItemHeader = styled.h2`
  font-family: Montserrat;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  -webkit-letter-spacing: 0.21px;
  -moz-letter-spacing: 0.21px;
  -ms-letter-spacing: 0.21px;
  letter-spacing: 0.21px;
  text-align: left;

  #document-proof {
    font-weight: normal;
  }
`

export const ItemHeader = styled(CentredItemHeader)`
  margin-bottom: 0;
`

export const ItemSecondaryHeader = styled(ItemHeader)`
  font-size: 12px;
  font-weight: normal;
`

export const SectionSeparator = styled.hr`
  border: 1px solid #ddd;
`

export const InputGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));

  span:not(#text-input) {
    display: none;
  }
`

export const Container = styled.form`
  display: grid;
  grid-template-rows: 100px 1fr;
`

export const ErrorContainer = styled.div`
  strong {
    color: ${Colours.red};
  }
`
